var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWallet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.35996 3.38C2.04019 3.38 0.959961 4.46024 0.959961 5.78V8.66V11.54V12.5V14.8634V19.22C0.959961 20.5453 2.03468 21.62 3.35996 21.62H20.64C21.9652 21.62 23.04 20.5453 23.04 19.22V14.8634V12.5V11.54V8.66V5.78C23.04 4.46024 21.9597 3.38 20.64 3.38H3.35996ZM3.35996 4.34H20.64C21.4408 4.34 22.08 4.97913 22.08 5.78V6.75407C21.6772 6.44852 21.1814 6.26 20.64 6.26H3.35996C2.81855 6.26 2.32271 6.44852 1.91996 6.75407V5.78C1.91996 4.97913 2.55909 4.34 3.35996 4.34ZM3.35996 7.22H20.64C21.4408 7.22 22.08 7.85913 22.08 8.66V9.63407C21.6772 9.32852 21.1814 9.14 20.64 9.14H3.35996C2.81855 9.14 2.32271 9.32852 1.91996 9.63407V8.66C1.91996 7.85913 2.55909 7.22 3.35996 7.22ZM3.35996 10.1H20.64C21.4408 10.1 22.08 10.7391 22.08 11.54V12.5H17.0953C16.0546 12.5 15.1032 13.088 14.6381 14.0188L14.4581 14.3778C13.992 15.3085 13.0411 15.8966 12 15.8966C10.9588 15.8966 10.0079 15.3085 9.54277 14.3778L9.36371 14.0188C8.89811 13.0876 7.94577 12.5 6.90465 12.5H1.91996V11.54C1.91996 10.7391 2.55909 10.1 3.35996 10.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWallet);
export default __webpack_public_path__ + "static/media/wallet.aab00559.svg";
export { ForwardRef as ReactComponent };